import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Table, Tooltip, Image, Modal } from "antd";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import { CheckCircleOutlined, FileImageOutlined } from "@ant-design/icons";

const PendingList = () => {
  const [subscriptionList, setSubscriptionList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [visible, setVisible] = useState({ open: false, id: null });
  const scaleStep = 0.5;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmPlanDialog, setConfirmPlanDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const { rerunNotif } = useContext(NotificationInfo);

  const columns = [
    {
      title: "Applied Date",
      dataIndex: "created_at",
      render: (text, record) => (
        <p>
          {moment(new Date(text), "YYYY-MM-DD").format("MMMM DD, YYYY HH:mm")}
        </p>
      ),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      render: (text, record) => <p>{text}</p>,
    },

    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.subscriptionpaymentmerchantinfo.reg_firstname !== null
            ? text.subscriptionpaymentmerchantinfo.reg_firstname
            : ""}{" "}
          {text.subscriptionpaymentmerchantinfo.reg_lastname !== null
            ? text.subscriptionpaymentmerchantinfo.reg_lastname
            : ""}
        </p>
      ),
    },
    {
      title: "Email",
      render: (text) => <p>{text.subscriptionpaymentuser.email}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <div style={{ width: 80 }}>
          <Tooltip title="Confirm Payment">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setConfirmPlanDialog(true);
                setSelectedData(text);
              }}
              icon={<CheckCircleOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip title="Payment Attachment">
            <div
              style={{
                display: "none",
              }}
            >
              <Image
                width={200}
                src=""
                preview={{
                  visible: visible.id === text.id ? visible.open : false,
                  scaleStep,
                  src: `${import.meta.env.VITE_API_IMAGE}subscription-payment/${
                    text.payment_screenshot
                  }`,
                  onVisibleChange: (value) => {
                    setVisible({ ...visible, open: value });
                  },
                }}
                alt="payment-img"
              />
            </div>

            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setVisible({ open: true, id: text.id });
              }}
              icon={<FileImageOutlined />}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getSubscriptionList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 1 };
    axios
      .get("user/admin/subscription-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSubscriptionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getSubscriptionList();
  }, [getSubscriptionList]);

  const handleEPaymentOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmPlanDialog(false);
      setConfirmLoading(false);
      handleConfirmPaymentForAPlan();
    }, 2000);
  };

  const handleConfirmPaymentForAPlan = () => {
    var planExpiry =
      selectedData !== null
        ? selectedData.plan_duration === "12 months"
          ? moment(selectedData.subscriptionsubscribe.plan_expiry)
              .add(12, "M")
              .format("YYYY-MM-DD HH:mm:ss")
          : moment(selectedData.subscriptionsubscribe.plan_expiry)
              .add(6, "M")
              .format("YYYY-MM-DD HH:mm:ss")
        : "";

    const formdata = new FormData();
    formdata.append("id", selectedData !== null && selectedData.id);
    formdata.append("user_id", selectedData !== null && selectedData.user_id);
    formdata.append("plan", selectedData !== null && selectedData.plan);

    formdata.append(
      "sku_limit",
      selectedData !== null
        ? // selectedData.plan === "basic" ? 30 :
          selectedData.plan === "standard"
          ? 30
          : 9999999999
        : ""
    );
    formdata.append(
      "account_limit",
      selectedData !== null
        ? // selectedData.plan === "basic" ? 1 :
          selectedData.plan === "standard"
          ? 2
          : 9999999999
        : ""
    );
    formdata.append(
      "enable_sales_report",
      selectedData !== null
        ? // selectedData.plan === "basic" ? 0 :
          selectedData.plan === "standard"
          ? 1
          : 1
        : ""
    );
    formdata.append(
      "enable_inventory_report",
      selectedData !== null
        ? // selectedData.plan === "basic" ? 0 :
          selectedData.plan === "standard"
          ? 0
          : 1
        : ""
    );
    formdata.append(
      "plan_expiry",
      selectedData !== null
        ? moment(selectedData.subscriptionsubscribe.plan_expiry).format(
            "YYYY-MM-DD HH:mm:ss"
          ) > moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
          ? planExpiry
          : moment(new Date()).add(12, "M").format("YYYY-MM-DD HH:mm:ss")
        : ""
    );

    axios
      .post("user/admin/confirm-payment-plan", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm payment for a plan successfully.");
          setTimeout(() => {
            setLoading(false);
            getSubscriptionList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={
          subscriptionList.data.length > 0 ? subscriptionList.data : []
        }
        scroll={scroll}
        rowKey={(record) => record.id}
      />

      <Modal
        title="Are you sure to confirm this payment for a specific plan?"
        open={confirmPlanDialog}
        onOk={handleEPaymentOk}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmPlanDialog(false)}
        centered
      />
    </div>
  );
};

export default PendingList;
